import React from 'react';
import { useDebug } from '../shared/DebugContext';

const DebugMenu = ({ isVisible, onClose }) => {
  const { logs, clearLogs } = useDebug();

  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        width: '400px',
        height: '90vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        border: '1px solid #444',
        borderRadius: '8px',
        overflowY: 'auto',
        padding: '10px',
        zIndex: 9999,
        fontFamily: 'monospace',
        fontSize: '12px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Debug Menu</h3>
        <div>
          <button onClick={clearLogs} style={{ marginRight: '5px' }}>Clear</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
      <hr style={{ borderColor: '#444' }} />
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {logs.map((log, index) => (
          <li key={index} style={{ marginBottom: '10px', borderBottom: '1px solid #555', paddingBottom: '10px' }}>
            <div>
              <strong>[{new Date(log.timestamp).toLocaleTimeString()}] {log.type.toUpperCase()}</strong>
            </div>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0 }}>
              {JSON.stringify(log.data, null, 2)}
            </pre>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DebugMenu;
